import React from "react";
import PropTypes from "prop-types";
import {NavLink} from 'react-router-dom';

import styles from './navigation.module.css';
/**
 * 
 * @param {JSX.Element} icon A valid Icon component
 * @param {JSX.Element | string} label the label to display
 * @returns 
 */
const NavItem = ({icon,label,to,...props}) => {

    return (
        <NavLink to={`${to}`} 
        {...props}>
             {({ isActive }) => (
                <div className={`${styles.NavItem} ${isActive? styles.active :""}`}>
                    <span className={styles.icon}>{icon}</span>
                    <span>{label}</span>
                </div>
            )}
            
        </NavLink>
    )

}

NavItem.propTypes = {
    icon: PropTypes.element.isRequired,
    label: PropTypes.oneOfType([PropTypes.string,PropTypes.element])
}

export default NavItem;